// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2KeGF","alertIcon":"ConfirmModal_alertIcon__1EjUg"};